import Page from "components/base/Page";
import { NavigationLink } from "components/base/base";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import FinalQcReportPage from "./components/FinalQcReportPage";
import PoQcReportPage from "./components/PoQcReportPage";
import Preview from "./components/Preview";
import FinalQcReportListPage from "./final";
import InlineReportForm from "./inline/Form";
import InlineReportList from "./inline/List";
import InlineReportPreview from "./inline/Preview";
import Dashboard from "./Dashboard";
import PoDashboard from "./PoDashboard";
import PoQcReportListPage from "./po-reports";

const Menu = () => (
  <div className="flex space-x-4">
    <NavigationLink to="/qc/todo" title="Dashboard" />
    <NavigationLink to="/qc/reports" title="Final Reports" />
    <NavigationLink to="/qc/po-todo" title="Stock To-do" />
    <NavigationLink to="/qc/po-reports" title="Stock Reports" />
    <NavigationLink to="/qc/inline" title="In Line Inspection" />
  </div>
);

function QCPage() {
  return (
    <Routes>
      <Route
        element={
          <Page leftButtons={<Menu />}>
            <Outlet />
          </Page>
        }
      >
        <Route path="todo" element={<Dashboard />} />
        <Route path="reports" element={<FinalQcReportListPage />} />
        <Route path="po-todo" element={<PoDashboard />} />
        <Route path="po-reports" element={<PoQcReportListPage />} />
        <Route path="inline" element={<InlineReportList />} />
      </Route>

      <Route path="reports/:id" element={<FinalQcReportPage />} />
      <Route path="reports/:id/preview" element={<Preview />} />
      <Route path="po-reports/:id" element={<PoQcReportPage />} />
      <Route path="po-reports/:id/preview" element={<Preview />} />

      <Route path="inline/:id" element={<InlineReportForm />} />
      <Route path="inline/:id/preview" element={<InlineReportPreview />} />

      <Route path="*" element={<Navigate to="/qc/todo" />} />
    </Routes>
  );
}

export default QCPage;
